//  =================================首页部分=====================================

// 设置被选中的菜单
export const INDEX_SETACTIVEMENU = 'INDEX_SETACTIVEMENU'
// 设置未读消息数量
export const INDEX_SET_UNREADNOTIFICATION = 'INDEX_SET_UNREADNOTIFICATION'
// 设置消息列表
export const INDEX_SET_NOTIFICATIONS = 'INDEX_SET_NOTIFICATIONS'
// 增加消息列表的数据
export const INDEX_PUSH_NOTIFICATIONS = 'INDEX_PUSH_NOTIFICATIONS'
// 设置消息为已读
export const INDEX_SET_NOTIFICATIONSREADED = 'INDEX_SET_NOTIFICATIONSREADED'
// 增加一个标签页
export const INDEX_ADD_PAGETAB = 'INDEX_ADD_PAGETAB'
// 删除一个标签页
export const INDEX_DEL_PAGETAB = 'INDEX_DEL_PAGETAB'

//  =================================用户信息部分=====================================
// 设置用户信息
export const AUTH_SETUSER = 'AUTH_SETUSER'



// WEBPACK FOOTER //
// ./src/store/mutations.js